export default {"src":"/_next/static/media/popover-leaves.e37d0db3.svg","height":242,"width":250};